
import { iterateOverFilters } from './utils'

export default {
  middlewareForRequest: ({ loadOptions }) => {
    loadOptions.filter = iterateOverFilters(loadOptions.filter, ([paramKeys, logicalOperator, filterValue]) => {
      if (paramKeys === 'chatDuration' && logicalOperator === '=' && filterValue && ~filterValue.indexOf(' - ')) {
        const values = filterValue.split(' - ')
        return [
          ['chatDuration', '>=', values[0]],
          'and',
          ['chatDuration', '<=', values[1]],
        ]
      }
      if (paramKeys === 'chatDuration' && logicalOperator === '=' && filterValue === 'N/A') {
        return ['chatDuration', '=', null]
      }
      return [paramKeys, logicalOperator, filterValue]
    })

    return loadOptions
  },
}
